var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showInput)?_c('div',{staticClass:"form-group"},[_c('gmap-autocomplete',{attrs:{"placeholder":"Start typing an address","options":_vm.autocompleteOptions},on:{"place_changed":_vm.setPlace}}),(_vm.showSubText)?_c('small',{staticClass:"form-text text-muted"},[_vm._v(_vm._s(_vm.subText))]):_vm._e()],1):_vm._e(),((_vm.place || _vm.location) && _vm.showMap)?_c('GmapMap',{staticStyle:{"width":"100%","height":"300px"},attrs:{"center":_vm.getCurrentLatLng(),"zoom":18,"options":{
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      disableDefaultUi: true
    },"map-type-id":"satellite"}},[_c('Gmap-Marker',{attrs:{"position":_vm.getCurrentLatLng(),"draggable":true},on:{"dragend":_vm.handleMarkerDrag}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }